import { SwapVert } from '@mui/icons-material';
import { IconButton, MenuItem } from '@mui/material';
import { Menu, MenuButton } from '@retail/components';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';

interface Props {
  handleUpdateStockedStatus: (isStocked: boolean) => void;
}

export function StockedStatusMenu({ handleUpdateStockedStatus }: Props) {
  const t = useMyAssortmentTFunction();
  return (
    <Menu>
      {({ onClose }) => (
        <>
          <MenuButton component={IconButton} sx={{ padding: 0 }}>
            <SwapVert fontSize="small" />
          </MenuButton>

          <MenuItem
            sx={{ py: 1 }}
            onClick={() => {
              handleUpdateStockedStatus(true);
              onClose();
            }}
          >
            {t('myAssortment.stockStatus.inStock')}
          </MenuItem>
          <MenuItem
            sx={{ py: 1 }}
            onClick={() => {
              handleUpdateStockedStatus(false);
              onClose();
            }}
          >
            {t('myAssortment.stockStatus.order')}
          </MenuItem>
        </>
      )}
    </Menu>
  );
}
